<template>
<div>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper pb-2">
            <div class="content-header row">
                <div class="content-header-left col-md-12 col-12 mb-1">
                    <div class="row breadcrumbs-top">
                        <div class="col-12">
                            <h3 class="content-header-title float-left mb-0">Welcome</h3>
                            <div class="breadcrumb-wrapper">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">Home
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-body">
                <section id="dashboard-ecommerce">
                    <div class="row match-height h-100">
                        <div class="col-lg-12 col-12">
                            <div class="row match-height">
                                <div class="col-lg-12 col-12 welcomeheight">
                                    <div class="card welcome_pageloginafter">
                                        <h2 style=""> Welcome to Control Tower</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
export default({
    name:'Welcome',
    data() {
        return {
            isLoading: false,
            search: {
                end_date: null,
                start_date: null
            },
            dataPoints: {
                today_gate_entry: 0,
                gate_exit: 0,
                today_dock_allocation: 0,
                dock_entry: 0,
                dock_exit: 0,
                vehicle_parked: 0,
                seal_count: 0,
                without_seal_count: 0,
                available_docks: 0,
                occupied_docks: 0,
                total_warehouses: 0,
                total_vehicles: 0,
                total_vendors: 0,
                total_gates: 0,
                total_docks: 0,
                total_zones: 0
            }
        }  
    } ,
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        VueElementLoading,
    },
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getDashboardDataCounts()
    },
    methods: {
        getDashboardDataCounts() {
            this.isLoading = true
            this.makeRequest("POST", "/stats/dashboard-data-points", this.search)
                .then(result => {
                    this.isLoading = false
                    this.dataPoints = result.data.data
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        resetFilters() {
            this.search.start_date = null
            this.search.end_date = null
            this.getDashboardDataCounts()
        }
    }
})
</script>

<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
.cardcenter{
    text-align: center;
    color: white;
}
.welcomeheight{
    height: 80vh;
}
.welcome_pageloginafter{
 display: flex;
 align-items: center;
 justify-content: center;
}
</style>